// src/validation.ts
var ASCII_ONLY_REGEX = /^[\x00-\x7F]*$/;
var ASCII_ONLY_MESSAGE = "We do not support special characters, please use standard characters only";
export {
  ASCII_ONLY_MESSAGE,
  ASCII_ONLY_REGEX
};
//# sourceMappingURL=validation.mjs.map